/**
 * FlowCrypt — Encrypt Gmail with PGP
 *
 * A single web-accessible-resource group exposes its compose/pgp UI, SVG icons, a
 * stylesheet and the logo, but scoped to mail.google.com, accounts.google.com and
 * www.google.com — not to every origin. With no use_dynamic_url the URLs are fixed, so
 * from Gmail the vendor-named logo and CSS are fetchable — but from any other origin the
 * resources are unreachable and a negative proves nothing.
 *
 * Manifest verified against version 8.5.14.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'bnjglocicdkmhmoohhfkfkbbkejdhdgc';

export const flowCrypt: ExtensionDefinition = {
  id: ID,
  name: 'FlowCrypt: Encrypt Gmail with PGP',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 70_000,
  requiredOrigin: 'https://mail.google.com',
  notes:
    'WAR scoped to Gmail/Google origins, not exposed to every page. The vendor-named ' +
    'flowcrypt-logo PNG is static, so only Gmail can detect it here.',
  signals: [
    {
      id: 'war-flowcrypt-logo',
      kind: 'web-accessible-resource',
      description:
        'Fetch img/logo/flowcrypt-logo-19-19.png — the vendor-named logo, exposed only to ' +
        'Gmail/Google origins at a fixed URL.',
      weight: 1,
      run: () => probeFetch(ID, 'img/logo/flowcrypt-logo-19-19.png'),
    },
    {
      id: 'war-webmail-css',
      kind: 'web-accessible-resource',
      description: 'Fetch css/webmail.css — the Gmail-injection stylesheet, a second path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'css/webmail.css'),
    },
    {
      id: 'war-unlock-svg',
      kind: 'web-accessible-resource',
      description: 'Fetch img/svgs/unlock.svg — a third scoped resource, an icon.',
      weight: 0.5,
      run: () => probeFetch(ID, 'img/svgs/unlock.svg'),
    },
  ],
};
